import { createFileRoute } from '@tanstack/react-router';
import { LayoutsRoute } from './-components';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/layouts/')({
  component: LayoutsRoute,
});
